import React, { useState } from "react";

const SizeSelector = ({ sizes, componentSize = "md", getSelectedSize, label = "Select Size", showLabel = false }) => {
  const [selectedSize, setSelectedSize] = useState("");

  const handleSizeSelect = (size) => {
    setSelectedSize(size);
    getSelectedSize(size);
  };

  const sizeStyles = {
    sm: {
      heading: "text-base font-semibold",
      button: "size-9 inline-flex items-center justify-center tracking-wide align-middle text-base text-center rounded-md",
      spacing: "space-x-1"
    },
    md: {
      heading: "text-lg font-semibold",
      button: "size-9 inline-flex items-center justify-center tracking-wide align-middle text-base text-center rounded-md",
      spacing: "space-x-2"
    },
    lg: {
      heading: "text-xl font-semibold", 
      button: "size-9 inline-flex items-center justify-center tracking-wide align-middle text-base text-center rounded-md",
      spacing: "space-x-3"
    }
  };

  const currentSize = sizeStyles[componentSize];

  return (
    <div className="size-selector">
      {showLabel && <h4 className={currentSize.heading}>{label}:</h4>}
      <ul className={`flex ${currentSize.spacing}`}>
        {sizes?.map((size, index) => (
          <li key={index}>
            <button
              onClick={() => handleSizeSelect(size)}
              className={`${currentSize.button} ${selectedSize === size ? 'bg-orange-500 text-white' : 'bg-orange-500/5 hover:bg-orange-500 text-orange-500 hover:text-white'}`}
            >
              {size}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SizeSelector;